module.exports = __webpack_public_path__ + "img/off.2b408bbd.svg";